<script>
import ConstMatter from '@/core/mixins/ConstMatterPixi'
import Matter from 'matter-js'
export default {
  name: 'Bounds',
  mixins: [ ConstMatter ],
  render: h => h(), 
  beforeDestroy() {
    this.removeBounds()
  },
  mounted() {
    console.log('Bounds');
    this.addBounds()
  },
  methods: {
    addBounds() {
        // var size = (!this.$root.$agent.smartphone) ? 20 : 5

        const size = 20

        this.$top = this.$Bodies.rectangle(
            window.innerWidth/2, 
            size, 
            window.innerWidth, 
            size*2, 
            {   isStatic: true, 
                collisionFilter: { category: this.$bounds_touch, mask: this.$body_touch }
            }
        )
        this.$bottom = this.$Bodies.rectangle(
            0, 
            window.innerHeight-size, 
            window.innerWidth/2, 
            size*2, 
            { 
                isStatic: true, 
                collisionFilter: { category: this.$bounds_touch, mask: this.$body_touch }
            }
        )

        this.$bottom2 = this.$Bodies.rectangle(
            window.innerWidth, 
            window.innerHeight-size, 
            window.innerWidth/2, 
            size*2, 
            { 
                isStatic: true, 
                collisionFilter: { category: this.$bounds_touch, mask: this.$body_touch }
            }
        )


        this.$left = this.$Bodies.rectangle(
            size, 
            window.innerHeight/2, 
            size*2, 
            window.innerHeight, 
            { 
                isStatic: true, 
                collisionFilter: { category: this.$bounds_touch, mask: this.$body_touch }
            }
        )
        this.$right = this.$Bodies.rectangle(
            window.innerWidth-size, 
            window.innerHeight/2, 
            size*2, 
            window.innerHeight, 
            { 
                isStatic: true, 
                collisionFilter: { category: this.$bounds_touch, mask: this.$body_touch }
            }
        )
        this.$World.add(this.$world, [ this.$bottom, this.$bottom2, this.$left, this.$right])

    },
    removeBounds() {
        this.$World.remove(this.$world, [this.$top, this.$bottom, this.$left, this.$right])
    },


  }
}
</script>














